"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Affiche "oui" ou "non" en fonction d'une entrée boolean
 */
ngModule.filter("yesOrNo", function () {
  return function yesOrNoFilter(value) {
    return value ? "Oui" : "Non";
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/filters/yesOrNo.filter.js
// module id = 2709
// module chunks = 13